// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"78":"1349669d","430":"867d6a9c","729":"749566bb"}[chunkId] + ".chunk.css";
};